import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { router } from './router'
import { registerServiceWorkerAutoReload } from '@shared-ui/utils/registerServiceWorkerAutoReload'
import { initRum } from './lib/rum'

/**
 * 相手（未ログイン）の回答画面かどうか。`/s/<token>` で開く。
 *
 * ⚠ **この画面では Service Worker を使わない**（PRODUCT_DEV-675）。理由は 2 つ。
 *
 * 1. **古いキャッシュのアプリが一瞬出る。** 実機で、メールのリンクを開くと 404 が一度
 *    表示され、そのあと回答画面に切り替わった。端末に前のビルドがキャッシュされており、
 *    そのビルドには `/s/:token` のルートがまだ無いため `*`（404 画面）に落ちてから、
 *    SW の更新 → 自動リロードで正しい画面になっていた。相手にとっては「リンクが切れている」
 *    ようにしか見えず、そこで閉じられたら回答は返ってこない。
 * 2. **社外の人の端末にアプリ一式をキャッシュさせない。** 1 回きり開くページのために
 *    数 MB を precache する理由が無い。
 *
 * SW を登録しないので、この画面は常にネットワークから最新の HTML を取る。
 */
const isGuestScheduling = window.location.pathname.startsWith(
  `${import.meta.env.BASE_URL}s/`.replaceAll("//", "/"),
);

// PRODUCT_DEV-471: リリース後の自動反映 (3プロダクト共通)
if (!isGuestScheduling) registerServiceWorkerAutoReload();

// PRODUCT_DEV-493: CloudWatch RUM 初期化（VITE_RUM_* 未設定環境では no-op）
initRum();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App router={router} />
  </StrictMode>,
)
